<button dlsButton class="pt-quiet-default pt-icon-only" *ngIf="actions&&actions.length > 0"
        (click)="actionClicked($event)"
        (clickOutside)="closeActions()"
        [dlsMenuTriggerFor]="worklistMenu">
    <dls-icon class="pt-icon worklist-actions-button icon__more_info"></dls-icon>
</button>
<dls-menu #worklistMenu>
    <dls-menu-item *ngFor="let action of actions; trackBy: trackByKey" [disabled]="!shouldEnableAction(action)">
            <label (click)="shouldEnableAction(action) && applyAction(action.action, action)">
                {{action.label | stringTranslate}}
            </label>
    </dls-menu-item>
</dls-menu>
